/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
import auth from './modules/auth'
import app from './modules/app'
import user from './modules/user'
import address from './modules/address'
import organisations from './modules/organisations'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  modules : {
    auth, app, user, organisations, address
  }
})

export default store
